<template>
    <div>
        <div class="container font-manrope-semi-bold mb-5">
            <h1 class="fl-eqh-c text-primary fs-lg text-center mt-5 ml-lg-5">
                Partner Agencies
            </h1>

            <div class="boxes mt-5 row ml-md-0">
                <template v-if="details === null || details.length === 0">
                    <p>Currently, No partners to list.</p>
                </template>

                <template v-else>
                    <div
                        class="col-lg-4 col-md-6 mt-5 d-flex"
                        v-for="(item, i) in details"
                        :key="i"
                    >
                        <div class="partner-card bs-10">

                            <!-- Image -->
                            <div class="logo-wrapper">
                                <img
                                    v-if="item.logo"
                                    :src="item.logo"
                                    class="logo-img"
                                    alt="logo"
                                    @error="hideBrokenImage"
                                >
                            </div>

                            <!-- Content -->
                            <div class="card-content">
                                <h5>{{ item.name }}</h5>

                                <p class="parag">
                                    {{ item.description }}
                                </p>
                            </div>

                            <!-- Footer -->
                            <div class="card-footer">
                                <p
                                    @click="openSiteUrl(item.website_link)"
                                    class="cursor-pointer text-primary"
                                >
                                    View Website
                                    <img
                                        src="../../../assets/img/Images/icons/pinned-icon.svg"
                                        class="ml-2"
                                        alt="icon"
                                    >
                                </p>
                            </div>

                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'agencies',

    props: {
        details: {
            type: Array,
            default: null
        }
    },

    methods: {
        openSiteUrl (link) {
            if (link) {
                window.open(link, '_blank');
            }
        },

        hideBrokenImage (event) {
            event.target.style.display = 'none';
        }
    }
};
</script>

<style scoped>

h1 {
    color: #0E196D;
}

.fs-lg {
    font-size: 2.1rem;
}

.boxes {
    padding: 2px 27px;
}

/* Card */

.partner-card {
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 540px;
    background: #fff;
    box-shadow: rgb(167 171 187) 0 4px 4px 0;
}

/* Image Area */

.logo-wrapper {
    width: 100%;
    height: 220px;
    background: #fff;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
}

.logo-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.card-content {
    flex: 1;
    padding: 18px;
    overflow: hidden;
}

.card-content h5 {
    color: #000;
    margin-bottom: 15px;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;

    /* Show full title */
    white-space: normal;
    overflow-wrap: break-word;
    word-break: break-word;
    hyphens: auto;
}
.parag {
    color: #676767;
    text-align: justify;
    line-break: anywhere;

    display: -webkit-box;
    -webkit-line-clamp: 5; /* Maximum 5 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 120px;
}

/* Footer */

.card-footer {
    padding: 18px;
    margin-top: auto;
    background: transparent;
    border-top: none;
}

.card-footer p {
    margin: 0;
}

/* Shadow */

.bs-10 {
    box-shadow: rgb(167 171 187) 0 4px 4px 0;
}

/* Responsive */

@media (max-width:768px){

    .boxes{
        padding:0;
    }

    .partner-card{
        min-height:auto;
    }

}

</style>
